<template>
  <SearchAddressFields
    v-if="hasAddressSearch"
    :address="address"
    :houseNumber="houseNumber"
    :showHouseNumber="showHouseNumber"
    :zipcode="zipcode"
    :city="city"
    :required="required"
    :testId="testId"
    @update:address="$emit('update:address', $event)"
    @update:houseNumber="$emit('update:houseNumber', $event)"
    @update:zipcode="$emit('update:zipcode', $event)"
    @update:city="$emit('update:city', $event)"
  />
  <ManualAddressFields
    v-else
    :address="address"
    :houseNumber="houseNumber"
    :showHouseNumber="showHouseNumber"
    :zipcode="zipcode"
    :city="city"
    :required="required"
    :testId="testId"
    @update:address="$emit('update:address', $event)"
    @update:houseNumber="$emit('update:houseNumber', $event)"
    @update:zipcode="$emit('update:zipcode', $event)"
    @update:city="$emit('update:city', $event)"
  />
</template>

<script
  lang="ts"
  setup
>
import { computed, ref } from 'vue';
import { useCompanyStore } from '@/stores/company';
import ManualAddressFields from './ManualAddressFields.vue';
import SearchAddressFields from './SearchAddressFields.vue';

withDefaults(
  defineProps<{
    address?: string;
    // Only used when showHouseNumber is set - see the comment in SearchAddressFields.vue.
    houseNumber?: string;
    showHouseNumber?: boolean;
    zipcode?: string;
    city?: string;
    required?: boolean;
    testId?: string;
  }>(),
  {
    address: '',
    houseNumber: '',
    showHouseNumber: false,
    zipcode: '',
    city: '',
    required: false,
    testId: 'customer',
  },
);

defineEmits<{
  (e: 'update:address', value: string): void;
  (e: 'update:houseNumber', value: string): void;
  (e: 'update:zipcode', value: string): void;
  (e: 'update:city', value: string): void;
}>();

// Countries with a dedicated free-text address search API (see AddressLookup::Providers) - those
// companies search by street name instead of typing a postcode + house number.
const ADDRESS_SEARCH_COUNTRIES = ['nl'];

const { company } = useCompanyStore();
const hasAddressSearch = computed(() =>
  ADDRESS_SEARCH_COUNTRIES.includes(company.country),
);
</script>
